import { EventEmitter, Component, ViewChild, ContentChild, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogConfig, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AwButtonModule } from '@aw/ads-components/aw-button';
import { BreakpointObserver } from '@angular/cdk/layout';
import { FloatingDialogConstants } from '@aw/ads-components/src/constants';
import { getUniqueID } from '@aw/ads-components/src/utils';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/dialog';
import * as ɵngcc2 from '@angular/cdk/layout';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@aw/ads-components/aw-button';

const _c0 = ["modalButtonContent"];
const _c1 = ["floatingModalTemplate"];
function AwFloatingDialogComponent_aw_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "aw-button", 4);
    ɵngcc0.ɵɵlistener("onClick", function AwFloatingDialogComponent_aw_button_3_Template_aw_button_onClick_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return !ctx_r3.isDialogOpen ? ctx_r3.openDialog() : ctx_r3.closeDialog(); });
    ɵngcc0.ɵɵelementStart(1, "i", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("styleClasses", ctx_r0.buttonConfig.buttonClasses)("aw-aria-label", ctx_r0.buttonConfig.buttonLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.buttonIcon);
} }
function AwFloatingDialogComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "aw-button", 7);
    ɵngcc0.ɵɵprojection(2, 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 8);
    ɵngcc0.ɵɵprojection(4, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 9);
    ɵngcc0.ɵɵprojection(6, 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("aw-aria-label", ctx_r2.dismissButtonLabel)("mat-dialog-close", true);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("id", ctx_r2.headerElementId);
} }
const _c2 = [[["", "dialog-button", ""]], [["", "modal-close", ""]], [["", "modal-header", ""]], "*"];
const _c3 = ["[dialog-button]", "[modal-close]", "[modal-header]", "*"];
function buttonInitialState() {
    return {
        buttonClasses: 'btn-floating btn-large btn-primary',
        buttonIcon: 'share',
        buttonLabel: 'open dialog'
    };
}
class AwFloatingDialogComponent {
    constructor(matDialog, breakpointObserver) {
        this.matDialog = matDialog;
        this.breakpointObserver = breakpointObserver;
        this.position = FloatingDialogConstants.defaultPosition;
        this.sideOffset = FloatingDialogConstants.defaultOffset;
        this.bottomOffset = FloatingDialogConstants.defaultOffset;
        this.buttonConfig = buttonInitialState();
        this.config = {
            panelClass: ['aw-modal', 'modal-sm']
        };
        this.dismissButtonLabel = 'Dismiss';
        this.dialogOpen = new EventEmitter();
        this.dialogClosed = new EventEmitter();
        this.elementId = getUniqueID();
        this.isDialogOpen = false;
        this.mobileBreakpoint = '(max-width: 767px)';
        this.defaultPanelClass = ['adaptive-dialog'];
    }
    get headerElementId() {
        return `header-${this.elementId}`;
    }
    ngOnInit() {
        this.mobileScreenSubscription = this.breakpointObserver
            .observe(this.mobileBreakpoint)
            .pipe()
            .subscribe((state) => {
            this.isMobileView = !!state.matches;
        });
        this.changeButtonIcon();
        this.initStyles();
    }
    ngOnDestroy() {
        this.mobileScreenSubscription.unsubscribe();
    }
    openDialog() {
        this.isDialogOpen = true;
        this.dialogOpen.emit();
        this.changeButtonIcon();
        const dialogConfig = Object.assign(new MatDialogConfig(), this.config);
        const dialogBottomOffset = +this.bottomOffset + this.getButtonSize() + FloatingDialogConstants.modalOffset;
        dialogConfig.panelClass = [...this.config.panelClass, ...this.defaultPanelClass];
        if (!this.isMobileView) {
            dialogConfig.position = { [this.position]: `${this.sideOffset}px`, bottom: `${dialogBottomOffset}px` };
            dialogConfig.maxHeight = window.innerHeight - dialogBottomOffset - FloatingDialogConstants.headerHeight;
            dialogConfig.minHeight = FloatingDialogConstants.dialogMinHeight;
            dialogConfig.maxWidth = FloatingDialogConstants.dialogMaxWidth;
            dialogConfig.minWidth = FloatingDialogConstants.dialogMinWidth;
        }
        dialogConfig.ariaLabelledBy = this.headerElementId;
        this.dialogRef = this.matDialog.open(this.modalTemplate, dialogConfig);
        this.dialogRef.updatePosition(dialogConfig.position);
        this.dialogRef.afterClosed().subscribe(() => {
            this.closeDialog();
        });
    }
    closeDialog() {
        this.isDialogOpen = false;
        this.changeButtonIcon();
        this.dialogRef.close();
        this.dialogClosed.emit();
    }
    initStyles() {
        this.floatingDialogStyles = {
            position: 'fixed',
            bottom: `${this.bottomOffset}px`,
            [this.position]: `${this.sideOffset}px`,
        };
    }
    changeButtonIcon() {
        this.buttonIcon = this.isDialogOpen ? 'close' : this.buttonConfig.buttonIcon;
    }
    getButtonSize() {
        return this.modalButtonContent ? FloatingDialogConstants.regularButtonSize : FloatingDialogConstants.buttonSize;
    }
}
AwFloatingDialogComponent.ɵfac = function AwFloatingDialogComponent_Factory(t) { return new (t || AwFloatingDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MatDialog), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.BreakpointObserver)); };
AwFloatingDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwFloatingDialogComponent, selectors: [["aw-floating-dialog"]], contentQueries: function AwFloatingDialogComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, _c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalButtonContent = _t.first);
    } }, viewQuery: function AwFloatingDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalTemplate = _t.first);
    } }, inputs: { position: "position", sideOffset: "sideOffset", bottomOffset: "bottomOffset", buttonConfig: "buttonConfig", config: "config", dismissButtonLabel: "dismissButtonLabel" }, outputs: { dialogOpen: "dialogOpen", dialogClosed: "dialogClosed" }, ngContentSelectors: _c3, decls: 6, vars: 3, consts: [[1, "floating-dialog-wrap", 3, "ngStyle"], [3, "click"], [3, "styleClasses", "aw-aria-label", "onClick", 4, "ngIf"], ["floatingModalTemplate", ""], [3, "styleClasses", "aw-aria-label", "onClick"], ["aria-hidden", "true", 1, "material-icons-outlined"], [1, "modal-content-wrapper"], ["styleClasses", "mat-dialog-close icon-link", 3, "aw-aria-label", "mat-dialog-close"], [1, "modal-heading", "no-border", 3, "id"], [1, "modal-content"]], template: function AwFloatingDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c2);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function AwFloatingDialogComponent_Template_div_click_1_listener() { return !ctx.isDialogOpen ? ctx.openDialog() : ctx.closeDialog(); });
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, AwFloatingDialogComponent_aw_button_3_Template, 3, 3, "aw-button", 2);
        ɵngcc0.ɵɵtemplate(4, AwFloatingDialogComponent_ng_template_4_Template, 7, 3, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ctx.floatingDialogStyles);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-label", ctx.buttonConfig.buttonLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.modalButtonContent);
    } }, directives: [ɵngcc3.NgStyle, ɵngcc3.NgIf, ɵngcc4.AwButtonComponent, ɵngcc1.MatDialogClose], encapsulation: 2 });
AwFloatingDialogComponent.ctorParameters = () => [
    { type: MatDialog },
    { type: BreakpointObserver }
];
AwFloatingDialogComponent.propDecorators = {
    modalTemplate: [{ type: ViewChild, args: ['floatingModalTemplate', { static: true },] }],
    modalButtonContent: [{ type: ContentChild, args: ['modalButtonContent', { static: true },] }],
    position: [{ type: Input }],
    sideOffset: [{ type: Input }],
    bottomOffset: [{ type: Input }],
    buttonConfig: [{ type: Input }],
    config: [{ type: Input }],
    dismissButtonLabel: [{ type: Input }],
    dialogOpen: [{ type: Output }],
    dialogClosed: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwFloatingDialogComponent, [{
        type: Component,
        args: [{
                selector: 'aw-floating-dialog',
                template: "<div class=\"floating-dialog-wrap\" [ngStyle]=\"floatingDialogStyles\">\n    <div\n        [attr.aria-label]=\"buttonConfig.buttonLabel\" (click)=\"!isDialogOpen ? openDialog() : closeDialog()\">\n        <ng-content select=\"[dialog-button]\"></ng-content>\n    </div>\n    <aw-button\n        *ngIf=\"!modalButtonContent\"\n        [styleClasses]=\"buttonConfig.buttonClasses\"\n        [aw-aria-label]=\"buttonConfig.buttonLabel\"\n        (onClick)=\"!isDialogOpen ? openDialog() : closeDialog()\"\n        >\n        <i class=\"material-icons-outlined\" aria-hidden=\"true\">{{ buttonIcon }}</i>\n    </aw-button>\n    <ng-template #floatingModalTemplate>\n        <div class=\"modal-content-wrapper\">\n            <aw-button\n                [aw-aria-label]=\"dismissButtonLabel\"\n                styleClasses=\"mat-dialog-close icon-link\"\n                [mat-dialog-close]=\"true\">\n                <ng-content select=\"[modal-close]\"></ng-content>\n            </aw-button>\n            <div class=\"modal-heading no-border\" id=\"{{headerElementId}}\">\n                <ng-content select=\"[modal-header]\"></ng-content>\n            </div>\n            <div class=\"modal-content\">\n                <ng-content></ng-content>    \n            </div>\n        </div>\n    </ng-template>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc1.MatDialog }, { type: ɵngcc2.BreakpointObserver }]; }, { position: [{
            type: Input
        }], sideOffset: [{
            type: Input
        }], bottomOffset: [{
            type: Input
        }], buttonConfig: [{
            type: Input
        }], config: [{
            type: Input
        }], dismissButtonLabel: [{
            type: Input
        }], dialogOpen: [{
            type: Output
        }], dialogClosed: [{
            type: Output
        }], modalTemplate: [{
            type: ViewChild,
            args: ['floatingModalTemplate', { static: true }]
        }], modalButtonContent: [{
            type: ContentChild,
            args: ['modalButtonContent', { static: true }]
        }] }); })();

class AwFloatingDialogModule {
}
AwFloatingDialogModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwFloatingDialogModule });
AwFloatingDialogModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwFloatingDialogModule_Factory(t) { return new (t || AwFloatingDialogModule)(); }, imports: [[
            CommonModule,
            MatDialogModule,
            AwButtonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwFloatingDialogModule, { declarations: function () { return [AwFloatingDialogComponent]; }, imports: function () { return [CommonModule,
        MatDialogModule,
        AwButtonModule]; }, exports: function () { return [AwFloatingDialogComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwFloatingDialogModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatDialogModule,
                    AwButtonModule
                ],
                declarations: [
                    AwFloatingDialogComponent
                ],
                exports: [
                    AwFloatingDialogComponent
                ]
            }]
    }], null, null); })();

export { AwFloatingDialogComponent, AwFloatingDialogModule };

//# sourceMappingURL=aw-ads-components-aw-floating-dialog.js.map